import { OrderStatus } from 'types/OrderStatus'

/**
* getPieChartData
* @param {Object} normalizedDetails normalized details of order
* @param {boolean} isSmall Is small screen used
* @param {number} total total quantity ordered
* @returns {Array} Chart data array
*/
export const getPieChartData = (normalizedDetails: any, isSmall: any, total: any, status: any) => {
  const deliveredTrucks = normalizedDetails.delivered.noOfTrucks
    ? `${normalizedDetails.delivered.noOfTrucks} TRUCK${normalizedDetails.delivered.noOfTrucks > 1 ? `S` : ``}`
    : ``
  const scheduledTrucks = normalizedDetails.scheduled.noOfTrucks
    ? `${normalizedDetails.scheduled.noOfTrucks} TRUCK${normalizedDetails.scheduled.noOfTrucks > 1 ? `S` : ``}`
    : ``
  const chartParts = [
    [`${isSmall ? `` : `\n`}Scheduled\n${normalizedDetails.scheduled.loadQty}m3\n${scheduledTrucks}`, normalizedDetails.scheduled.loadQty],
    [
      `${isSmall ? `` : `\n`}In Transit\n${normalizedDetails.inTransit.loadQty}m3\n${normalizedDetails.inTransit.noOfTrucks} TRUCK${
        normalizedDetails.inTransit.noOfTrucks > 1 ? `S` : ``
      }${isSmall ? `\n\n` : ``}`,
      normalizedDetails.inTransit.loadQty,
    ],
    [
      `${isSmall ? `` : `\n`}Delivered\n${normalizedDetails.delivered.loadQty}m3\n${deliveredTrucks}${isSmall ? `\n\n` : ``}`,
      normalizedDetails.delivered.loadQty,
    ],
  ]

  if (normalizedDetails.plusOrder && status !== OrderStatus.ORDER_STATUS_CANCELLED && status !== OrderStatus.ORDER_STATUS_COMPLETED) {
    const percentage = (normalizedDetails.delivered.loadQty + normalizedDetails.inTransit.loadQty + normalizedDetails.scheduled.loadQty) * 0.05
    chartParts.unshift([null, percentage || total * 0.05])
  } else {
    chartParts.unshift([null, null])
  }

  chartParts.unshift([``, ``])
  return chartParts
}

/**
* Updates progress
* @param {Object} currentDeliveryDetails Delivery details
* @returns {Object} Normalized details
*/
export const normalizeDeliveryDetails = (currentDeliveryDetails: any) => {
  const { scheduled } = currentDeliveryDetails.data.orders.loads
  const inTransit = currentDeliveryDetails.data.orders.loads.intransit
  const { delivered } = currentDeliveryDetails.data.orders.loads

  /**
   * Updates previous value
   * @param {number} acc accumulator value
   * @param {string} el value
   * @returns {Object} Normalized details
   */
  const updatePrev = (acc: any, el: any) => {
    acc += Number(el.loadQty)
    return acc
  }

  const normalizedDetails: any = {}
  if (scheduled.length > 0) {
    normalizedDetails.scheduled = {
      loadQty: Number(scheduled.reduce(updatePrev, 0).toFixed(1)),
      noOfTrucks: scheduled.length,
    }
  } else {
    normalizedDetails.scheduled = {}
  }

  if (delivered.length > 0) {
    normalizedDetails.delivered = {
      loadQty: Number(delivered.reduce(updatePrev, 0).toFixed(1)),
      noOfTrucks: delivered.length,
    }
  } else {
    normalizedDetails.delivered = {}
  }

  if (inTransit.length > 0) {
    normalizedDetails.inTransit = {
      loadQty: Number(inTransit.reduce(updatePrev, 0).toFixed(1)),
      noOfTrucks: inTransit.length,
    }
  } else {
    normalizedDetails.inTransit = {}
  }

  // next ETA, reviewdOnJobTime needs to be number of millisceconds
  normalizedDetails.nextEtaTime = inTransit && inTransit[0] ? Number(getEta(inTransit[0])) : null
  return normalizedDetails
}


/**
 * Returns the ETA
 * @param {Object} load The load
 * @returns {string} The ETA
 */
const getEta = (load: any) => {
  const {
    reviewedOnJobTime,
    truck: { eta },
  } = load
  if (eta.trim().length > 0) {
    return eta.trim()
  }
  return reviewedOnJobTime.trim()
}
